import { apiSlice } from "../../app/api/apiSlice";

export const loanDocumentsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		loanDocuments: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/get_filtered_documents/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useLoanDocumentsMutation } = loanDocumentsApiSlice;
